import { $api } from "@/shared/api";

export async function getRoom(roomId: number, withoutSortLectures = false) {
    return await $api.get(`/room/${roomId}/`)
        .then(res => {
            console.log(`/room/${roomId}`, res);
            let data = res?.data?.room;
            // @ts-ignore
            if (!withoutSortLectures) data?.lectures?.sort?.((a, b) => (new Date(a?.from_time) - new Date(b?.from_time)))
            return data;
        })
        .catch(console.log)
}